import { makeService } from './api';

const service = makeService('addons');

export default service;